import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ColorModeScript, ChakraProvider as Provider, useColorMode } from '@chakra-ui/react';
import { theme as appTheme } from '@/utils/chakra-theme';
import useAppStore from '@/stores/AppStore';
var colorModeManager = {
    type: 'localStorage',
    set: function(value) {
        return useAppStore.getState().setColorMode(value);
    },
    get: function() {
        return useAppStore.getState().colorMode;
    }
};
function ZustandColorModeSync(param) {
    var children = param.children;
    var colorMode = useAppStore(function(state) {
        return state.colorMode;
    });
    var setColorMode = useColorMode().setColorMode;
    React.useEffect(function() {
        setColorMode(colorMode);
    }, [
        colorMode,
        setColorMode
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
function ChakraProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ColorModeScript, {
                initialColorMode: appTheme.config.initialColorMode
            }),
            /*#__PURE__*/ _jsx(Provider, {
                colorModeManager: colorModeManager,
                theme: appTheme,
                portalZIndex: 40,
                children: /*#__PURE__*/ _jsx(ZustandColorModeSync, {
                    children: children
                })
            })
        ]
    });
}
export default ChakraProvider;
